import { render, staticRenderFns } from "./vkDetailsModal.vue?vue&type=template&id=3d29b8ad&"
import script from "./vkDetailsModal.vue?vue&type=script&lang=js&"
export * from "./vkDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./vkDetailsModal.vue?vue&type=style&index=0&id=3d29b8ad&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports